import React from 'react'
import { Box, Typography,Grid} from '@mui/material'
import BeenhereIcon from '@mui/icons-material/Beenhere';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import InsightsIcon from '@mui/icons-material/Insights';

const data = [
    {
        id:'1',
        title:'Protection on the road',
        desp:'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
        icon:<BeenhereIcon sx={{color:"#2B817B"}}/>
    },
    {
        id:'2',
        title:'Cash out any time',
        desp:'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
        icon:<HourglassBottomIcon sx={{color:"#2B817B"}}/>
    },
    {
        id:'3',
        title:'Track your earnings',
        desp:'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
        icon:<InsightsIcon sx={{color:"#2B817B"}}/>
    }
];

const JoinUs = () => {
  return (
    <Box>
        <Box sx={{mt:'70px'}}>
            <Box>
                <Typography sx={{
                    fontWeight:600,
                    fontSize:'30px',
                    textAlign:'center'
                }}>
                    Why join as our Driver Partner ?
                </Typography>
                <Typography variant="body2" sx={{
                    fontWeight:400,
                    fontSize:'13px',
                    textAlign:'center'
                }}>
                    Get various benefits by joining as a EatCoast Driver Partner.
                </Typography>
            </Box>
            <Box>
                <Box sx={{mt:'50px'}}>
                    <Grid container spacing={2} sx={{
                        
                        display:'flex',
                        flexDirection:'row',
                        justifyContent:'center'
                    }}>
                    {
                        data && data.map((v,i)=>{
                            return(
                                <>
                                    <Grid item xl={3.5} lg={3.5} md={4} sm={4} xs={12}>
                                        <Box sx={{
                                            width:"100%",
                                            border:'1px solid #E1E1E6',
                                            height:{xl:'auto',lg:'auto',md:'auto',sm:'270px',xs:'auto'},
                                            borderRadius:'5px',
                                            padding:'30px'
                                        }}>
                                            <Box sx={{
                                                display:'flex',
                                                flexDirection:'column',
                                                alignItems:'center',
                                                justifyContent:'center',
                                                width:"auto"
                                            }}>
                                                <Box sx={{
                                                    width:'60px',
                                                    height:'60px',
                                                    border:'1px solid #E1E1E6',
                                                    borderRadius:'50%',
                                                    display:'flex',
                                                    flexDirection:'row',
                                                    justifyContent:'center',
                                                    alignItems:'center'
                                                }}>
                                                    {v.icon}
                                            </Box>
                                            <Box>
                                                <Typography sx={{
                                                    fontWeight:600,
                                                    fontSize:'20px',
                                                    textAlign:'center',
                                                    mt:'30px'
                                                }}>
                                                    {v.title}
                                                </Typography>
                                                <Typography sx={{
                                                    fontWeight:300,
                                                    fontSize:'14px',
                                                    color:'#545359',
                                                    textAlign:'center'
                                                }}>
                                                    {v.desp}
                                                </Typography>
                                            </Box>
                                            </Box>
                                            </Box>
                                    </Grid>
                                </>
                            )
                        })
                    }
                    </Grid>
                </Box>
            </Box>
        </Box>
    </Box>
  )
}

export default JoinUs